import { ChangeEventHandler, KeyboardEventHandler, useContext, useEffect, useState } from "react";
import Loading from "../Generic/loading";
import { tenantContext } from "../Main/contexts";
import {
    CreateGlobalRole,
    DeleteGlobalRole,
    GetGlobalRole,
    GetGlobalRoleResponse,
    GetGlobalRoles,
    GetPermissions,
    GlobalRolesListItemDTO,
    PermissionDTO,
    UpdateGlobalRole,
} from "./TenantAPI";
import ToggleSwitch from "../Generic/ToggleSwitch";
import { PlusCircle } from "react-feather";

function Global() {
    const [isLoading, setIsLoading] = useState<Boolean>(true);
    const { selectedTenant } = useContext(tenantContext);
    const [permissions, setPermissions] = useState<Array<PermissionDTO>>([]);
    const [allRoles, settAllroles] = useState<Array<GlobalRolesListItemDTO>>([]);
    const [selectedRole, setSelectedRole] = useState<GetGlobalRoleResponse | undefined>(undefined);
    const [isNewRole, setIsNewRole] = useState<Boolean>(true);
    useEffect(() => {
        (async () => {
            if (selectedTenant) {
                const permisionsResult = await GetPermissions(selectedTenant.token);
                if (permisionsResult.isOk) {
                    setPermissions(permisionsResult.data?.items!);
                }
                const allRoles = await GetGlobalRoles(selectedTenant.token);
                if (allRoles.isOk) {
                    settAllroles(allRoles.data?.items!);
                }
                setIsLoading(false);
                setSelectedRole(undefined);
            }
        })();
    }, [selectedTenant]);

    const getRolePermissions = async (id: number) => {
        if (selectedTenant) {
            const result = await GetGlobalRole(selectedTenant?.token, id);
            if (result.isOk) {
                setSelectedRole(result.data);
                setIsNewRole(false);
            }
        }
    };

    const updatePermission = (field: string, checked: boolean) => {
        let sRole: GetGlobalRoleResponse = JSON.parse(JSON.stringify(selectedRole));
        if (sRole.permissions?.find(x => x.toString() == field)) {
            sRole.permissions = sRole.permissions.filter(x => x.toString() != field);
        } else {
            sRole.permissions?.push(parseInt(field));
        }
        setSelectedRole(sRole);
    };

    const updateRoleName = (e: React.FormEvent<HTMLInputElement>) => {
        let sRole: GetGlobalRoleResponse = JSON.parse(JSON.stringify(selectedRole));
        sRole.name = e.currentTarget.value;
        setSelectedRole(sRole);
    };
    const updateRole = async () => {
        if (validateRole()) {
            if (selectedTenant && selectedRole && selectedRole.id) {
                const result = await UpdateGlobalRole(selectedTenant.token, selectedRole.id, {
                    name: selectedRole?.name,
                    permissions: selectedRole.permissions,
                });
                if (result.isOk) {
                    const allRoles = await GetGlobalRoles(selectedTenant.token);
                    if (allRoles.isOk) {
                        settAllroles(allRoles.data?.items!);
                    }
                    alert("Role updated");
                    setSelectedRole(undefined);
                }
            }
        }
    };
    function addRole() {
        setIsNewRole(true);
        setSelectedRole({ name: "", permissions: [] });
    }

    function validateRole(): boolean {
        let isValid = true;
        if (selectedRole) {
            if (selectedRole.name == "") {
                alert("Name cannot be blank");
                isValid = false;
            }
            if (isValid && selectedRole.name.length > 256) {
                alert("Name cannot exceed 256 characters");
                isValid = false;
            }
        }
        return isValid;
    }

    async function createRole() {
        if (validateRole()) {
            if (selectedTenant && selectedRole) {
                const result = await CreateGlobalRole(selectedTenant.token, {
                    name: selectedRole.name,
                    permissions: selectedRole.permissions,
                });
                if (result.isOk) {
                    const allRoles = await GetGlobalRoles(selectedTenant.token);
                    if (allRoles.isOk) {
                        settAllroles(allRoles.data?.items!);
                    }
                    alert("Role Created");
                    setSelectedRole(undefined);
                }
            }
        }
    }

    async function deleteRole() {
        let confirmDelete = window.confirm("Are you sure you want to delete this role?");
        if (confirmDelete && selectedTenant && selectedRole && selectedRole.id) {
            const result = await DeleteGlobalRole(selectedTenant.token, selectedRole.id);
            if (result.isOk) {
                const allRoles = await GetGlobalRoles(selectedTenant.token);
                if (allRoles.isOk) {
                    settAllroles(allRoles.data?.items!);
                }
                alert("Role Deleted");
                setSelectedRole(undefined);
            }
        }
    }

    return (
        <>
            {isLoading && <Loading></Loading>}
            {!isLoading && (
                <>
                    <div className="topSection">
                        <div className="sectionHeader">
                            <PlusCircle
                                className="headerIcon"
                                onClick={addRole}
                            ></PlusCircle>{" "}
                            Roles - Global
                        </div>
                        {selectedRole && !isNewRole && (
                            <div>
                                <button
                                    className="g-btn-large btn-warning"
                                    onClick={deleteRole}
                                >
                                    {" "}
                                    Delete Role
                                </button>{" "}
                                &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
                                <button
                                    className="g-btn-large btn-primary"
                                    onClick={updateRole}
                                >
                                    {" "}
                                    Update Role{" "}
                                </button>
                            </div>
                        )}
                        {selectedRole && isNewRole && (
                            <div>
                                <button
                                    className="g-btn-large btn-primary"
                                    onClick={createRole}
                                >
                                    {" "}
                                    Create Role{" "}
                                </button>
                            </div>
                        )}
                    </div>
                    <div style={{ display: "flex", flexDirection: "row", height: "calc(100% - 44px)" }}>
                        <div className="bodyCol1">
                            {allRoles
                                .slice()
                                .sort((a, b) => (a.name ?? "").localeCompare(b.name ?? ""))
                                .map(x => {
                                    return (
                                        <div
                                            className={
                                                selectedRole?.id == x.id ? "optionsRow selectedItem " : "optionsRow"
                                            }
                                            onClick={() => {
                                                getRolePermissions(x.id);
                                            }}
                                        >
                                            <div className="optionsRowLink"> {x.name}</div>
                                        </div>
                                    );
                                })}
                        </div>
                        {selectedRole && (
                            <div className="bodyCol2">
                                <div className="Header">
                                    <div style={{ padding: "8px 9px 0px 0px" }}>
                                        <input
                                            type="text"
                                            maxLength={256}
                                            style={{ width: "100%", height: "30px" }}
                                            value={selectedRole.name}
                                            onChange={updateRoleName}
                                        ></input>
                                    </div>
                                </div>
                                <div className="optionsRow">
                                    <p
                                        style={{
                                            marginBottom: "6px",
                                            marginTop: "-0px",
                                            fontWeight: "bold",
                                            fontSize: "12pt",
                                        }}
                                    >
                                        Permissions
                                    </p>
                                </div>
                                {permissions
                                    .slice()
                                    .sort((a, b) => (a.label ?? "").localeCompare(b.label ?? ""))
                                    .filter(p => p.type == "Tenant")
                                    .map(x => {
                                        return (
                                            <div className="optionsRow">
                                                <ToggleSwitch
                                                    name={x.id.toString()}
                                                    value={x.id.toString()}
                                                    checked={
                                                        selectedRole.permissions.find(i => i == x.id) ? true : false
                                                    }
                                                    label={x.label}
                                                    returnFunc={updatePermission}
                                                ></ToggleSwitch>
                                            </div>
                                        );
                                    })}
                            </div>
                        )}
                    </div>
                </>
            )}
        </>
    );
}
export default Global;
